import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Returns a Set of sold-out item ids (from the kitchen's 86 board).
export const useAvailability = () => {
  const [soldOut, setSoldOut] = useState(new Set());
  useEffect(() => {
    fetch(`${API}/menu`)
      .then((r) => r.json())
      .then((d) => setSoldOut(new Set((d.items || []).filter((i) => i.soldOut).map((i) => i.id))))
      .catch(() => {});
  }, []);
  return soldOut;
};
